import type { UserAccountProps } from 'utils/types';

export const isDentistRecordEligibleForCeDirectory = (
  user: Pick<UserAccountProps, 'id' | 'dentistId' | 'dentist'> | null | undefined,
): boolean => {
  if (!user || !Number.isSafeInteger(Number(user.id)) || Number(user.id) <= 0) return false;
  const dentistRecordId = user.dentistId ?? user.dentist?.id;
  return Number.isSafeInteger(Number(dentistRecordId)) && Number(dentistRecordId) > 0;
};
